import { render, staticRenderFns } from "./OrderForecastCopacking.vue?vue&type=template&id=3212ec69"
import script from "./OrderForecastCopacking.vue?vue&type=script&lang=js"
export * from "./OrderForecastCopacking.vue?vue&type=script&lang=js"
import style0 from "./OrderForecastCopacking.vue?vue&type=style&index=0&id=3212ec69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports